import { render, staticRenderFns } from "./TaskType.vue?vue&type=template&id=75fb1e1b&scoped=true&"
import script from "./TaskType.vue?vue&type=script&lang=js&"
export * from "./TaskType.vue?vue&type=script&lang=js&"
import style0 from "./TaskType.vue?vue&type=style&index=0&id=75fb1e1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fb1e1b",
  null
  
)

export default component.exports